// SILL-173: widget for the journey-rail "add-property" step's detail
// pane. Empty state shows a CTA only; with properties, shows a count
// summary and a CTA to add another. Pure UI; the controller decides
// routing into the properties view.

import { ArrowRight, MapPin } from "lucide-react";

import type { TrackedProperty } from "../../../lib/dashboard";
import { Button } from "../../ui/button";

export interface AddPropertyWidgetProps {
  onAddProperty: () => void;
  trackedProperties: readonly TrackedProperty[];
}

export function AddPropertyWidget({
  onAddProperty,
  trackedProperties,
}: AddPropertyWidgetProps) {
  const count = trackedProperties.length;
  const hasAny = count > 0;
  const summary = hasAny
    ? `${count} ${count === 1 ? "property" : "properties"} tracked`
    : "No properties tracked yet";

  return (
    <div
      className="flex w-full flex-col gap-2"
      data-slot="add-property-widget"
    >
      <div className="flex items-center gap-2">
        <MapPin aria-hidden="true" className="h-4 w-4 text-muted-foreground" />
        <p className="text-sm font-medium text-foreground">{summary}</p>
      </div>
      {hasAny ? (
        <ul className="space-y-1 text-xs text-muted-foreground">
          {trackedProperties.slice(0, 2).map((p) => (
            <li className="truncate" key={p.id}>
              {p.address} · {p.cityMeta}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-xs text-muted-foreground">
          Track a listing to see live affordability and qualification signals.
        </p>
      )}
      <Button
        className="self-start"
        onClick={onAddProperty}
        size="sm"
        variant="outline"
      >
        {hasAny ? "Add another property" : "Track a property"}
        <ArrowRight aria-hidden="true" className="ml-1 h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
